import { ActionTypes } from "../constants/action-types";
import { fromJS } from "immutable";
import { handleActions } from "redux-actions";

export const initialStateLineChart = {
  objectType: "SALE",
  chartType: "line",
  title: "Deal Performance",
  subtitle: "Last year",
  valueKey: "dealCount",
  valueFunc: "count",
  nameKey: "bucketId",
  segmentBy: "bucketId",
  dateUnit: "day",
  comparisonBy: "none",
  filters: {},
  filterRule: { rules: [{ data: {} }] },
  icons: [],
  colors: [],
  goalId: null,
  selectedColumns: [],
};

export const initialStateBarChart = {
  objectType: "SALE",
  chartType: "bar",
  title: "Deal Performance",
  subtitle: "Last year",
  valueKey: "dealCount",
  valueFunc: "count",
  nameKey: "bucketId",
  segmentBy: "None",
  dateUnit: "day",
  comparisonBy: null,
  filters: {},
  filterRule: { rules: [{ data: {} }] },
  icons: [],
  colors: [],
  goalId: null,
  selectedColumns: [],
};

export const initialStateColumnChart = {
  objectType: "SALE",
  chartType: "column",
  title: "Deal Performance",
  subtitle: "Last year",
  valueKey: "dealCount",
  valueFunc: "count",
  nameKey: "bucketId",
  segmentBy: "None",
  dateUnit: "day",
  comparisonBy: null,
  filters: {},
  filterRule: { rules: [{ data: {} }] },
  icons: [],
  colors: [],
  goalId: null,
  selectedColumns: [],
};

export const initialStatePieChart = {
  objectType: "SALE",
  chartType: "pie",
  title: "Deal Performance",
  subtitle: "Last year",
  valueKey: "dealCount",
  valueFunc: "count",
  nameKey: "bucketId",
  segmentBy: "bucketId",
  dateUnit: "day",
  comparisonBy: null,
  filters: {},
  filterRule: { rules: [{ data: {} }] },
  icons: [],
  colors: [],
  goalId: null,
  selectedColumns: [],
};

export const initialStateScoreCard = {
  objectType: "SALE",
  chartType: "bar",
  title: "Deal Performance",
  subtitle: "Last year",
  valueKey: "dealCount",
  valueFunc: "count",
  nameKey: "bucketId",
  segmentBy: "None",
  dateUnit: "day",
  comparisonBy: null,
  filters: {},
  filterRule: { rules: [{ data: {} }] },
  icons: [],
  colors: [],
  goalId: null,
  selectedColumns: [],
};

export const initialStateGoalChart = {
  objectType: "SALE",
  chartType: "bar",
  title: "Deal Performance",
  subtitle: "Last year",
  valueKey: null,
  valueFunc: null,
  nameKey: "start",
  segmentBy: "None",
  dateUnit: null,
  comparisonBy: null,
  filters: {},
  filterRule: { rules: [{ data: {} }] },
  icons: [],
  colors: [],
  goalId: null,
  selectedColumns: [],
};

export const initialStateTable = {
  objectType: "SALE",
  chartType: "bar",
  title: "Deal Performance",
  subtitle: "Last year",
  valueKey: "dealCount",
  valueFunc: "count",
  nameKey: "bucketId",
  segmentBy: "None",
  dateUnit: "day",
  comparisonBy: null,
  filters: {},
  filterRule: { rules: [{ data: {} }] },
  icons: [],
  colors: [],
  goalId: null,
  selectedColumns: [],
};

export const initialState = fromJS({
  activeTab: "Filter",
  data: initialStateLineChart,
  table: {
    page: 0,
    pageSize: 10,
    pagination: {},
    search: "",
    rows: [],
    loading: false,
    selectedColumns: [],
  },
});

export const actions = {
  [ActionTypes.settingActiveTabReport]: {
    next(state, { payload }) {
      const newState = {
        ...state.toJS(),
        activeTab: payload,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.settingDataReport]: {
    next(state, { payload }) {
      const newState = {
        ...state.toJS(),
        data: payload,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.resetSettingDataReport]: {
    next() {
      return initialState;
    },
  },
  [ActionTypes.settingTableReport]: {
    next(state, { payload }) {
      const js = state.toJS();
      const table = { ...(js.table || {}), ...(payload || {}) };
      return fromJS({ ...js, table });
    },
  },
};

export const reportSetting = handleActions(actions, initialState);
